import specs from "./specs";
import imagesLoaded from "imagesloaded";
import utils from "./utils";
import { customLogger } from "@/utils";

function setUpMatomo(token) {
  // Instal Matomo
  // imagesLoaded("ul.product_list", { background: true }, function () {
    // Adding attributes to tack with matomo
    // const links = document.querySelector("div.product-image-container > a");
    // if (links != undefined) {
    //   for (let index = 0; index < links.length; index++) {
    //     links[index].setAttribute("data-track-content", "");
    //     links[index].setAttribute("data-content-name", "product_card");
    //   }
    // }

    try {
      window.matomoTracker = Matomo.getTracker();

      matomoTracker.setUserId(token);
      matomoTracker.setSiteId(specs._MATOMO_SITE_ID); // 5 = DF
      matomoTracker.setTrackerUrl("https://matomo.cleed.com/matomo.php");
      matomoTracker.trackPageView();
      matomoTracker.enableLinkTracking();
      matomoTracker.trackVisibleContentImpressions();

      specs._FUNCTION_TRACKING(matomoTracker, utils.intercept);

      // customLogger("========= test matomoo ========");
      // matomoTracker.trackGoal(1, 10);
      // matomoTracker.trackEvent("Site", "Add to cart", "id_product - test");
      customLogger("connect to Matomo");
    } catch (err) {
      customLogger("Could not setup Matomo", err);
    }
  // });
}

export default setUpMatomo;
